import { apiClient } from "../../../lib";
import { CommitmentGraphData, CommitmentStateData } from "../types";

export const commimentsExposure = {

    getCommimentsExposureGraphData: async (): Promise<CommitmentGraphData> => {
        const response = await apiClient.get(`/projects/commitment-analysis`);
        return response.data.data;
    },

    getCommimentsExposureStateData: async (): Promise<CommitmentStateData> => {
        const response = await apiClient.get(`/projects/commitment-exposure`);
        return response.data.data;
    },

    getCommimentsExposureListData: async () => {

    }

}